const util = {
    getNextIndex(index, length) {
        return index > length - 2 ? 0 : index + 1;
    },

    getPrevIndex(index, length) {
        return index > 0 ? index - 1 : length - 1;
    },

    getUpdatedIndex(dir, index, length) {
        return dir === 'next'
            ? util.getNextIndex(index, length)
            : util.getPrevIndex(index, length);
    },

    getPreloadIndex(dir, index, length) {
        const val = util.getUpdatedIndex(
            dir,
            util.getUpdatedIndex(dir, index, length),
            length
        );
        return val;
    },

    getTransitionDuration(
        transitionDirection,
        imageDirection,
        transitionDuration
    ) {
        if (
            transitionDirection === imageDirection ||
            transitionDirection === 'reset' ||
            (transitionDirection !== '' && imageDirection === 'either')
        ) {
            return `${transitionDuration}ms`;
        }
        return '';
    },

    appendBackgroundStyle(style, imageUrl) {
        if (imageUrl) {
            style.backgroundImage = `url(${imageUrl})`;
        }
        return style;
    },

    getProp(obj, prop) {
        return (obj && prop && obj[prop]) || null;
    },

    getImageSrc(image) {
        return util.getProp(image, 'src');
    },

    getAltText(image) {
        return util.getProp(image, 'altText');
    },

    getTemplateText(template, tokens = {}) {
        for (let key in tokens) {
            /* istanbul ignore else */
            if (tokens.hasOwnProperty(key)) {
                template = template.replace(`{${key}}`, tokens[key]);
            }
        }
        return template;
    },

    getPanningStyle(type, panPct) {
        if (!panPct) {
            return {
                current: {},
                next: {},
                prev: {}
            };
        }
        switch (type) {
            case 'slide':
                return {
                    current: {transform: `translateX(${panPct}%)`},
                    next: {transform: `translateX(${100 + panPct}%)`},
                    prev: {transform: `translateX(${-100 + panPct}%)`}
                };
            default:
                return {
                    current: {},
                    next: {},
                    prev: {}
                };
        }
    },

    getImageStyle({
        transitionDirection,
        imageDirection,
        image,
        transitionDuration,
        transitionStyle,
        panPct,
        slideType
    }) {
        const _transitionDuration = util.getTransitionDuration(
            transitionDirection,
            imageDirection,
            transitionDuration
        );
        return util.appendBackgroundStyle(
            {
                ...(_transitionDuration && {
                    transitionDuration: _transitionDuration
                }),
                ...util.getPanningStyle(transitionStyle, panPct)[slideType]
            },
            util.getImageSrc(image)
        );
    }
};

export default util;
